import ClientCURModule from "@/modules/ClientCUR";

function EditClientPage() {
  return <ClientCURModule type="edit" />;
}

export default EditClientPage;
